import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { PayeeCopyFormFieldComponent } from '../../payee-form-fields/payee-copy-form-field/payee-copy-form-field.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { RunTransitionResponse } from '../../services/workflow/workflow.service';

export type TransferInstructions = {
  transfer_amount: number;
  currency_iso: string;
  reference: string;
} & RunTransitionResponse;

@Component({
  selector: 'payee-transfer-instructions-dialog',
  templateUrl: './transfer-instructions-dialog.component.html',
  styleUrls: ['./transfer-instructions-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeCopyFormFieldComponent,
    PayeeButtonComponent,
    MatDialogClose,
    PayeeIconComponent,
    TranslateModule,
  ],
})
export class TransferInstructionsDialogComponent {
  private fb = inject(FormBuilder);
  readonly data = inject<TransferInstructions>(MAT_DIALOG_DATA);

  readonly form = this.fb.group({
    transfer_amount: this.fb.control(this.data.transfer_amount, {
      nonNullable: true,
    }),
    account_holder_name: this.fb.control('Legal Labs Kft.', {
      nonNullable: true,
    }),
    account_number: this.fb.control('12600016-19259526-84463815', {
      nonNullable: true,
    }),
    reference: this.fb.control(this.data.reference, { nonNullable: true }),
  });
}
